
import createApplicationSaga from "./createApplication.saga";
import fetchAllCoursesSaga from "./fetchAllCourses.saga";
import fetchFurtherDetailsSaga from "./fetchFurtherDetails.saga"
import fetchPersonalDetailsSaga from "./fetchPersonalDetails.saga"
import fetchQualificationSaga from "./fetchQualification.saga"
import fetchStudentCourseSaga from "./fetchStudentCourse.saga"
import submitApplicationSaga from "./submitApplication.saga"
import updateCourseSaga from "./updateCourse.saga"
import updateEvidenceSaga from "./updateEvidence.saga"
import udpateFurtherDetailsSaga from "./updateFurtherDetails.saga"
import updatePersonalDetailsSaga from "./updatePersonalDetails.saga"
import updateQualificationSaga from "./updateQualification.saga"
import deleteCourseSaga from "./deleteCourse.saga";
import deleteQualificationSaga from "./deleteQualification.saga";
import fetchStudentIDSaga from './getStudentId.saga';
import fetchApplication from "./fetchApplication.saga"
import submitConsentSaga from "./submitConsent.saga";

const StudentSagas = [
    createApplicationSaga(),
    fetchAllCoursesSaga(),
    fetchFurtherDetailsSaga(),
    fetchFurtherDetailsSaga(),
    fetchPersonalDetailsSaga(),
    fetchQualificationSaga(),
    fetchStudentCourseSaga(),
    submitApplicationSaga(),
    updateCourseSaga(),
    updateEvidenceSaga(),
    udpateFurtherDetailsSaga(),
    updatePersonalDetailsSaga(),
    updateQualificationSaga(),
    deleteCourseSaga(),
    deleteQualificationSaga(),
    fetchStudentIDSaga(),
    fetchApplication(),
    submitConsentSaga()


]

export default StudentSagas;